// App.js
import React, { useState, useEffect } from 'react';
import { ChakraProvider, CSSReset, Flex, Box, Heading, Image, Text, Link, HStack, Spinner, FormControl, FormLabel, Input, Button, Center, extendTheme } from '@chakra-ui/react';
import vk_music from './platforms/vk_music.svg';
import apple from './platforms/apple.svg';
import spotify from './platforms/spotify.svg';
import yandex from './platforms/yandex.svg';
import yt_music from './platforms/yt_music.svg';
import kion_music from './platforms/kion_music_icon_gradient.svg';
import zvuk from './platforms/ic_notification.png';
import wink from './platforms/wink.png';
import logo from './logo.svg';
import vk_s from './socials/VK.svg';
import yt_s from './socials/YouTube.svg';
import tk_s from './socials/TikTok.svg';
import tg_s from './socials/Telegram.svg';
import zen_s from './socials/Zen.svg';
import logo_bg from './socials/logo.png'
import { Icon24ChevronRightOutline } from '@vkontakte/icons'

import axios from 'axios';

const theme = extendTheme({
  fonts: {
    heading: 'Inter, sans-serif',
    body: 'Inter, sans-serif',
  },
  colors: {
    main: '#df2592',
  },
  styles: {
    global: {
      body: {
        fontFamily: 'Inter, sans-serif',
        color: '#23232B',
      },
    },
  },
});

function PlatformRow({ href, icon, name, fill, crop, glyph }) {
  if (!href) return null;
  return (
    <Link href={href} isExternal display="block" w="100%" _hover={{ textDecoration: 'none' }}>
      <Flex
        align="center"
        justify="space-between"
        gap="12px"
        px="14px"
        py="12px"
        bg="white"
        borderWidth="1px"
        borderColor="rgba(15, 23, 42, 0.06)"
        borderRadius="16px"
        style={{ boxShadow: '0 14px 24px -20px rgba(15, 23, 42, 0.24)' }}
        transition="border-color 0.2s ease, background 0.2s ease, transform 0.2s ease"
        _hover={{ borderColor: 'gray.200', bg: 'gray.50', transform: 'translateY(-1px)' }}
      >
        <Flex align="center" gap="12px" minW={0}>
          <Center boxSize="40px" borderRadius="12px" bg="rgba(15, 23, 42, 0.04)" overflow="hidden" flexShrink={0}>
            {crop ? (
              <Image src={icon} alt="" boxSize="60px" objectFit="cover" />
            ) : (
              <Image
                src={icon}
                alt=""
                boxSize={fill ? '40px' : glyph ? '26px' : '32px'}
                objectFit={glyph ? 'contain' : 'cover'}
              />
            )}
          </Center>
          <Text fontSize="14px" fontWeight={600} color="gray.800" noOfLines={1}>
            {name}
          </Text>
        </Flex>
        <Box color="gray.400" display="flex" flexShrink={0}>
          <Icon24ChevronRightOutline fill="#808080" />
        </Box>
      </Flex>
    </Link>
  );
}

function SocialButton({ href, icon, label }) {
  if (!href) return null;
  return (
    <Link
      href={href}
      isExternal
      aria-label={label}
      display="flex"
      alignItems="center"
      justifyContent="center"
      w="40px"
      h="40px"
      borderRadius="12px"
      bg="white"
      borderWidth="1px"
      borderColor="rgba(15, 23, 42, 0.06)"
      transition="transform 0.2s ease, background 0.2s ease"
      _hover={{ transform: 'translateY(-1px)', bg: 'gray.50', textDecoration: 'none' }}
    >
      <Image src={icon} boxSize="20px" alt="" />
    </Link>
  );
}

function PageShell({ children }) {
  return (
    <ChakraProvider theme={theme}>
      <CSSReset />
      <Flex direction="column" align="center" justify="center" minH="100vh" py="24px" px="16px" position="relative">
        <Box
          position="absolute"
          inset="0"
          backgroundImage={logo_bg}
          backgroundPosition="50% 50%"
          backgroundSize="cover"
          filter="blur(42px)"
          transform="scale(1.08)"
          zIndex={-2}
        />
        <Box position="absolute" inset="0" bg="rgba(255, 245, 250, 0.42)" zIndex={-1} />
        {children}
      </Flex>
    </ChakraProvider>
  );
}

function SiteFooter({ showLogo = true }) {
  return (
    <Box mt="20px" textAlign="center">
      {showLogo && (
        <Image src={logo} h="26px" mx="auto" mb="8px" objectFit="contain" alt="682 Distribution" />
      )}
      <Text fontSize="12px" color="gray.500" fontWeight={500}>
        © 2026 682 Distribution
      </Text>
    </Box>
  );
}


function App() {
  const [formData, setFormData] = useState({
    a_link_e: '',
    a_cover: '',
    a_title: '',
    a_artist: '',
    a_vk_link: '',
    a_ya_link: '',
    a_sp_link: '',
    a_yt_link: '',
    a_ap_link: '',
    a_password: ''
  });

  const [data, setData] = useState({
    cover: '',
    title: 'N/A',
    artist: 'N/A',
    vk_link: '',
    ya_link: '',
    sp_link: '',
    yt_link: '',
    ap_link: '',
    dr_link: '',
    zvuk_link: '',
    wink_link: '',
    social_vk: '',
    social_telegram: '',
    social_zen: '',
    social_tiktok: '',
    social_youtube: ''
  });

  const [admin, setAdmin] = useState(null);

  // Состояние для отслеживания статуса загрузки
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Получение значения из адресной строки (например, после / в ссылке)
    const pathParam = window.location.pathname.substring(1);

    // Сначала увеличиваем счетчик переходов
    axios.get(`https://api.682distribution.ru/increment_clicks?token=${pathParam}`)
      .then(() => {
        console.log('Счетчик переходов увеличен');
      })
      .catch(error => {
        console.error('Ошибка при увеличении счетчика:', error);
      });

    // Затем получаем данные о ссылке
    const apiUrl = `https://api.682distribution.ru/get_link?id=${pathParam}`;
    setAdmin(pathParam);

    axios.get(apiUrl)
      .then(response => {
        // Обработка ответа от сервера
        const responseData = response.data;
        setData({
          cover: 'https://api.682distribution.ru' + responseData.link.release.cover,
          title: responseData.link.release.title,
          artist: responseData.link.release.artists,
          vk_link: responseData.link.links.vk,
          ya_link: responseData.link.links.yandex,
          sp_link: responseData.link.links.spotify,
          yt_link: responseData.link.links.youtube,
          ap_link: responseData.link.links.apple,
          dr_link: responseData.link.links.deezer,
          zvuk_link: responseData.link.links.zvuk,
          wink_link: responseData.link.links.wink,
          social_vk: responseData.link.socials.vk,
          social_telegram: responseData.link.socials.telegram,
          social_zen: responseData.link.socials.zen,
          social_tiktok: responseData.link.socials.tiktok,
          social_youtube: responseData.link.socials.youtube
        });

        document.title = responseData.link.release.artists + ' - ' + responseData.link.release.title + ' | 682 Distribution';
        const metaDescriptionTag = document.querySelector('meta[name="description"]');
        if (metaDescriptionTag) {
          metaDescriptionTag.setAttribute('content', `Слушайте ${responseData.link.release.artists} - ${responseData.link.release.title} на всех площадках!`);
        }

        // Установка статуса загрузки в false после получения данных
        setLoading(false);
      })
      .catch(error => {
        // Обработка ошибок при запросе
        console.error('Error fetching data:', error);
      });

  }, []);


  if (data.cover && admin != 'admin-panel') {
    const hasSocials = data.social_vk || data.social_telegram || data.social_zen || data.social_tiktok || data.social_youtube;
    return (
      <PageShell>
        <Box
          w="100%"
          maxW="400px"
          overflow="hidden"
          borderRadius="28px"
          bg="linear-gradient(180deg, #FFFFFF 0%, #FFF7FB 100%)"
          boxShadow="0 12px 48px -8px rgba(223, 37, 146, 0.22)"
        >
          <Box position="relative" w="100%" pt="100%" overflow="hidden">
            {loading ? (
              <Center position="absolute" inset="0" bg="gray.50">
                <Spinner color="main" size="lg" />
              </Center>
            ) : (
              <Image
                src={`https://image.682distribution.ru/resize?image=${data.cover}&w=500&h=500`}
                alt={data.title}
                position="absolute"
                inset="0"
                w="100%"
                h="100%"
                objectFit="cover"
              />
            )}
          </Box>

          <Box px="20px" pt="16px" pb="8px" textAlign="center">
            <Heading as="h1" fontSize="20px" fontWeight={600} color="#23232B" lineHeight="1.3" noOfLines={2}>
              {loading ? <Spinner size="sm" color="main" /> : data.title}
            </Heading>
            <Text mt="4px" fontSize="14px" color="gray.500" noOfLines={1}>
              {loading ? '' : data.artist}
            </Text>
          </Box>

          <Box px="14px" pb="18px" display="flex" flexDirection="column" gap="8px">
            <PlatformRow href={data.vk_link} icon={vk_music} name="VK Музыка" fill />
            <PlatformRow href={data.ya_link} icon={yandex} name="Yandex Music" glyph />
            <PlatformRow href={data.sp_link} icon={spotify} name="Spotify" fill />
            <PlatformRow href={data.ap_link} icon={apple} name="Apple Music" fill />
            <PlatformRow href={data.yt_link} icon={yt_music} name="YouTube Music" fill />
            <PlatformRow href={data.dr_link} icon={kion_music} name="KION Музыка" glyph />
            <PlatformRow href={data.wink_link} icon={wink} name="Wink Музыка" fill />
            <PlatformRow href={data.zvuk_link} icon={zvuk} name="Звук" crop />

            {hasSocials && (
              <HStack spacing="8px" mt="8px" justify="center">
                <SocialButton href={data.social_vk} icon={vk_s} label="VK" />
                <SocialButton href={data.social_telegram} icon={tg_s} label="Telegram" />
                <SocialButton href={data.social_tiktok} icon={tk_s} label="TikTok" />
                <SocialButton href={data.social_youtube} icon={yt_s} label="YouTube" />
                <SocialButton href={data.social_zen} icon={zen_s} label="Дзен" />
              </HStack>
            )}
          </Box>
        </Box>
        <SiteFooter />
      </PageShell>
    );
  }

  else if (admin == 'admin-panel') {
    // Обработчик изменения значений полей формы
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value
      });
    };

    // Обработчик отправки формы
    const handleSubmit = async (e) => {
      e.preventDefault();

      try {
        // Отправка данных на сервер с использованием axios
        const response = await axios.post('https://server.nlmlink.ru/api/admin-panel', formData);

        // Обработка успешного ответа от сервера


        // Очистка формы или другие действия при успешной отправке
        setFormData({
          a_link_e: '',
          a_cover: '',
          a_title: '',
          a_artist: '',
          a_vk_link: '',
          a_ya_link: '',
          a_sp_link: '',
          a_yt_link: '',
          a_ap_link: '',
          a_password: ''
        });
      } catch (error) {
        // Обработка ошибки при отправке данных
        console.error('Ошибка отправки данных на сервер:', error);
      }
    };

    return (
      <ChakraProvider>
        <Box p={8} borderWidth="1px" borderRadius="lg">
          <form onSubmit={handleSubmit}>
            <FormControl mb={4}>
              <FormLabel>Ссылка</FormLabel>
              <Input type="text" name="a_link_e" onChange={handleChange} value={formData.a_link_e} />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Обложка</FormLabel>
              <Input type="text" name="a_cover" onChange={handleChange} value={formData.a_cover} />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Название</FormLabel>
              <Input type="text" name="a_title" onChange={handleChange} value={formData.a_title} />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Артист</FormLabel>
              <Input type="text" name="a_artist" onChange={handleChange} value={formData.a_artist} />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>ВКонтакте</FormLabel>
              <Input type="text" name="a_vk_link" onChange={handleChange} value={formData.a_vk_link} />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Яндекс</FormLabel>
              <Input type="text" name="a_ya_link" onChange={handleChange} value={formData.a_ya_link} />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Спотифай</FormLabel>
              <Input type="text" name="a_sp_link" onChange={handleChange} value={formData.a_sp_link} />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Ютуб</FormLabel>
              <Input type="text" name="a_yt_link" onChange={handleChange} value={formData.a_yt_link} />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Эпл</FormLabel>
              <Input type="text" name="a_ap_link" onChange={handleChange} value={formData.a_ap_link} />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Пароль</FormLabel>
              <Input type="password" name="a_password" onChange={handleChange} value={formData.a_password} />
            </FormControl>

            <Button type="submit" colorScheme="teal" mt={4}>
              Отправить
            </Button>
          </form>
        </Box>
      </ChakraProvider>
    )
  }
  else if (admin != 'admin-panel') {
    return (
      <PageShell>
        <Box
          w="100%"
          maxW="360px"
          py="36px"
          px="28px"
          borderRadius="28px"
          bg="linear-gradient(180deg, #FFFFFF 0%, #FFF7FB 100%)"
          boxShadow="0 12px 48px -8px rgba(223, 37, 146, 0.22)"
          textAlign="center"
        >
          <Image src={logo} maxW="168px" mx="auto" alt="682 Distribution" />
        </Box>
        <SiteFooter showLogo={false} />
      </PageShell>
    );
  }
}

export default App;

